<template>
  <div>
    <a
        class="text-blueGray-500 py-1 px-3"
        href="#pablo"
        ref="btnDropdownRef"
        v-on:click="toggleDropdown($event)"
    >
      <i class="fas fa-ellipsis-v"></i>
    </a>
    <div
        ref="popoverDropdownRef"
        class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
        v-bind:class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
      }"
        v-click-outside="hideDropdown"
    >
      <a
          @click="showLockerData"
          href="javascript:void(0);"
          class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
      >
        {{ $t('show_details') }}
      </a>
      <a
          @click="editLocker"
          href="javascript:void(0);"
          class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
      >
        {{ $t('edit') }} {{ $t('locker') }}
      </a>
      <a
          @click="deleteLocker"
          href="javascript:void(0);"
          class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
      >
        {{ $t('delete') }} {{ $t('locker') }}
      </a>
    </div>
  </div>
</template>
<script>
import { createPopper } from "@popperjs/core";
import AuthService from "../../../services/auth.service";

export default {
  data() {
    return {
      dropdownPopoverShow: false,
      dropdownClicksCounter: 0,
      AuthService
    };
  },

  methods: {
    toggleDropdown: function (event) {
      event.preventDefault();
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-start",
        });
      }
    },

    hideDropdown: function () {
      this.dropdownClicksCounter++;
      if(this.dropdownClicksCounter === 2) {
        this.dropdownClicksCounter = 0;
        if(this.dropdownPopoverShow)
          this.dropdownPopoverShow = !this.dropdownPopoverShow;
      }
    },

    showLockerData: function () {
      let locker = this.$parent.lockers[this.$props.index];
      this.$parent.showLockerData(locker);
    },

    editLocker: function() {
      this.$parent.setLockerIndex(this.$props.index);
      this.$parent.toggleEditLocker();
    },

    deleteLocker: function () {
      this.$fire({
        title: this.$t('confirm_delete'),
        text: this.$t('confirm_delete_locker'),
        type: "question",
        confirmButtonColor: "#fbbf24",
        showCancelButton: true,
      }).then(response => {
        if (response.value === true) {
          let locker = this.$parent.lockers[this.$props.index];
          // cancella l'armadio
          AuthService.deleteLocker(locker.id).then(
              response => {
                if (response.data.status === "success") {
                  // aggiorna gli armadi in caso di successo
                  AuthService.getLockers().then(
                      response => {
                        this.$parent.lockers = response.data.message;
                      }
                  );
                  this.$fire({
                    title: this.$t('success'),
                    text: this.$t('locker_deleted_succ'),
                    type: "success",
                    confirmButtonColor: "#fbbf24",
                    timer: 3000
                  });
                } else {
                  this.$fire({
                    title: this.$t('error'),
                    html: this.$t('error_occurred') + ".<br>(" + response.data.message + ")",
                    type: "error",
                    confirmButtonColor: "#fbbf24",
                    timer: 3000
                  });
                }
              });
        }
      });
    }
  },

  props: {
    index: Number,
  }
};
</script>
